module.exports = __webpack_public_path__ + "static/media/devices.839f8b2f.jpg";